import gql from 'graphql-tag'

export default gql`
query CA_gitBillPdf($billNumber: Int!, $cashRegisterId: ID!, $billDate: DateTime) {
	cashAssist {
		getBillPdf(billNumber: $billNumber, cashRegisterId: $cashRegisterId, billDate: $billDate) {
			url
		}
	}
}
`
